import Headroom from 'headroom.js';
import dropdownEvent from '../base/_dropdownEvent.js';

export default class Header {
	constructor(node = '.header', opts = {}) {
		this.node = typeof node === 'string' ? document.querySelector( node ) : node;
		document.addEventListener('DOMContentLoaded', function() {
		// your code here
		
		
		}, false);

	// personal/business menu tab activation on page load
	var tabs = document.querySelectorAll('.nav--primary > .nav__menu--level-0 > .nav__menu-item');
		if (window.location.href.indexOf("/business-banking/") > -1) {
			
			Array.prototype.forEach.call(tabs, function(tab, index) {
			if(tab.children[0].innerText == 'Business')
				tab.classList.add( 'nav--tabbed-active') ;	
			else 
				tab.classList.remove( 'nav--tabbed-active')

			});
		}
		else {
			Array.prototype.forEach.call(tabs, function(tab, index) {

			if(tab.children[0].innerText == 'Personal')
				tab.classList.add( 'nav--tabbed-active') ;	
			else 
				tab.classList.remove( 'nav--tabbed-active')

			});
		}
		if ( ! this.node instanceof HTMLElement ) {
			return;
		}

		this.opts = Object.assign(
			{
				headroom: {
					tolerance: {
						up: 7,
						down: 5
					},
					classes: {
						initial  : 'header',
						pinned   : 'header--pinned',
						unpinned : 'header--unpinned',
						top      : 'header--top',
						notTop   : 'header--not-top',
						bottom   : 'header--bottom',
						notBottom: 'header--not-bottom',
						frozen   : 'header--frozen',
					}
				},
				search: '.header__search',
				menu: '.header__menu',
			},
			opts
		);

		if ( typeof this.opts.headroom === 'object' ) {
			// headroom
			this.headroom = new Headroom(this.node, this.opts.headroom);
			this.headroom.init();
			this.headroom.update(this.headroom);
		}

		this.search    = typeof this.opts.search === 'string' ? this.node.querySelector(this.opts.search) : this.opts.search;
		this.hamburger = typeof this.opts.menu   === 'string' ? this.node.querySelector(this.opts.menu)   : this.opts.menu;

		// dropdowns
		const intentActivate = (e) => {
			// Array.from(this.node.querySelectorAll('.nav__menu--visible')).forEach((n) => {
			// 	n.classList.remove( 'nav__menu--visible') 
			// });
			Array.from( e.target.children ).filter( node => node.classList.contains( 'nav__menu' ) ).forEach( node => node.classList.add( 'nav__menu--visible') );
		}
		const intentDeactivate = (e) => {
			Array.from( e.target.children ).filter( node => node.classList.contains( 'nav__menu' ) ).forEach( node => node.classList.remove( 'nav__menu--visible') );
		}

		// Array.from(this.node.querySelectorAll('.nav__menu-item--level-0.menu-item-has-children')).forEach((node) => {
		// 	dropdownEvent(node);
		// 	node.addEventListener('dropdown:activate', intentActivate);
		// 	node.addEventListener('dropdown:deactivate', intentDeactivate);
		// });

		// Array.from(this.node.querySelectorAll('.nav__menu-item--level-1.menu-item-has-children')).forEach((node) => {
		// 	dropdownEvent(node);
		// 	node.addEventListener('dropdown:activate', intentActivate);
		// 	node.addEventListener('dropdown:deactivate', intentDeactivate);
		// });
		Array.from(this.node.querySelectorAll('.nav__menu-item--has-children')).forEach((node) => {
			dropdownEvent(node);
			node.addEventListener('dropdown:activate', intentActivate);
			node.addEventListener('dropdown:deactivate', intentDeactivate);
		});
	

		this.node.addEventListener('click', (e) => {
			let node = e.target;
			while( node && node.parentNode ) {
				if ( node === this.node ) {
					return;
				}
				// Navigate if primary menu (personal/business) is selected else prevent default
				if ( node.matches( '.nav__menu-item--has-children > .nav__link' ) && !(e.target.innerText == 'Personal' || e.target.innerText == 'Business')) {
					e.preventDefault();
				}

				node = node.parentNode;
			}
		});

	}
}
